import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';

import { Masterclass } from './masterclass/Masterclass';
import { Checkout } from './checkout/Checkout';
import { CompletePage } from './checkout/CompletePage';
import { WaitingList } from './waitingList/WaitingList';
import { FullScreenIframe } from './components/FullScreenIframe';
import { Count } from './masterclass/Count';
import { Returns } from './masterclass/Returns';
import { Video } from './masterclass/Video';

import './App.css';

const AppContent = ({ stripePromise }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/' || location.pathname === '/quiz') {
      document.title = 'Kate Jaskólska • QUIZ';
    } else if (location.pathname === '/mentoring') {
      document.title = 'Kate Jaskólska • Mentoring';
    } else if (location.pathname.startsWith('/masterclass')) {
      document.title =
        'SEKRETY KOBIECEGO MAGNETYZMU • Masterclass • Kate Jaskólska';
    }
  }, [location]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <div
            style={{
              width: '500px',
              margin: '20px auto',
            }}
          ></div>
        }
      />
      <Route
        path="/mentoring"
        element={
          <FullScreenIframe
            url="https://www.naffy.io/jaskolska.kate/konsultacje"
            title="Kate Jaskólska • Mentoring"
          />
        }
      />
      <Route path="/masterclass" element={<Masterclass />} />
      <Route path="/masterclass/video" element={<Video />} />
      <Route path="/masterclass/returns" element={<Returns />} />
      <Route path="/masterclass/countdown" element={<Count />} />
      <Route path="/masterclass/presale" element={<Masterclass />} />
      <Route path="/masterclass/waiting-list" element={<WaitingList />} />
      <Route
        path="/masterclass/checkout"
        element={<Checkout stripePromise={stripePromise} />}
      />
      <Route
        path="/masterclass/complete"
        element={<CompletePage stripePromise={stripePromise} />}
      />
    </Routes>
  );
};

export const App = () => {
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    setStripePromise(
      loadStripe(
        'pk_live_51QJMs5GTSAt8aHE2g5XynM8aZAEOEI0hsbi8jomOE2mYFIJYSesz7FXKgmu9YeJKWSz0OFSzlfhOuMEr7d347pOa00RVScInzP'
      )
    );
  }, []);

  return (
    <BrowserRouter>
      <AppContent stripePromise={stripePromise} />
    </BrowserRouter>
  );
};
